import { LoaderFunctionArgs } from 'react-router-dom';
import { getClient, getPersons } from '../Util/server';
import { msalInstance } from '..';
import { Client } from '../../backend/models/client';
import { Person } from '../../backend/models/person';

export type ClientLoaderResult = { client: Client; persons: Person[] };

const ClientLoader = async ({ params }: LoaderFunctionArgs): Promise<ClientLoaderResult> => {
  const loggedIn = Boolean(msalInstance.getActiveAccount());
  if (!loggedIn) {
    return {
      client: { id: '', name: '' },
    } as ClientLoaderResult;
  }
  const [client, persons] = await Promise.all([getClient(params.name), getPersons()]);
  return { client, persons };
};

export default ClientLoader;
